import React, { useEffect } from 'react';
import { Select } from '@prio365/prio365-react-library';
import { ProjectId } from '../../../models/Types';
import { useTranslation } from 'react-i18next';
import { apiGetProjectPhases } from '../../projects/api';
import { useQuery } from '@tanstack/react-query';

interface ProjectPhasePickerProps {
  projectId: ProjectId;
  onChange: (value: string) => void;
  disabled?: boolean;
  value?: string;
  setHasProjectPhases?: (hasProjectPhases: boolean) => void;
}

const ProjectPhasePicker: React.FC<ProjectPhasePickerProps> = ({
  projectId,
  onChange,
  disabled,
  value,
  setHasProjectPhases,
}) => {
  //#region ------------------------------ Defaults
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const { data: projectPhases, isLoading } = useQuery({
    queryKey: ['projectPhases', projectId],
    queryFn: async () => {
      const data = await apiGetProjectPhases(projectId);
      return data;
    },
    enabled: !!projectId,
  });
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  useEffect(() => {
    if (setHasProjectPhases) {
      setHasProjectPhases(projectPhases?.data.length > 0);
    }
  }, [setHasProjectPhases, projectPhases]);
  //#endregion

  return (
    <Select
      loading={!disabled && isLoading}
      onChange={onChange}
      disabled={disabled}
      value={value}
      placeholder={t(
        `projects:projectPhase.${disabled ? 'empty' : 'pickerPlaceholder'}`
      )}
      options={projectPhases?.data
        ?.sort((a, b) => a.name.localeCompare(b.name))
        ?.map((phase) => {
          return {
            value: phase.projectPhaseId,
            label: phase.name,
            key: phase.projectPhaseId,
          };
        })}
    ></Select>
  );
};

export default ProjectPhasePicker;
